import ProductImage from "../../../assets/images/bbhc/iStock-1484110897 1.png"
import { Button } from "../../../components/ui/button"
import { SvgVerified } from "../../../components/icons"
import { useNavigate } from "react-router-dom"

interface Props {
  isBootcamp?: boolean
  isCountdownActive?: boolean
}

const ProgramOverview: React.FC<Props> = ({
  isBootcamp,
  isCountdownActive,
}) => {
  const navigate = useNavigate()

  const handleBootcampRegistration = () => {
    navigate("/5daybusinessbootcamp/registration")
  }

  return (
    <div className="py-[56px] md:py-[96px] flex flex-col overflow-hidden md:px-[144px] px-4 sm:px-8 max-w-screen-xl mx-auto">
      <div className="mb-10 w-full">
        <h2 className="text-black text-[48px] font-bold leading-tight mb-0 text-left">
          {isBootcamp
            ? "Build An Abundant Coaching Business"
            : "Learn How to Build a Thriving Practice"}
        </h2>
        <p className="text-black text-[20px] font-normal text-left">
          {isBootcamp
            ? "In just 5 days, you’ll gain clarity and confidence in the key areas that matter most for your business:"
            : "In just three months, you'll walk away with a fully operational coaching practice, plus learn how to..."}
        </p>
      </div>
      <div className="flex flex-col md:flex-row items-start gap-6 lg:gap-12">
        <div className="flex flex-col gap-6 flex-1">
          {isBootcamp ? (
            <>
              {[
                {
                  title: "Day 1: Your Identity",
                  description:
                    "Anchor your business in who you are: your story, values, and unique genius.",
                },
                {
                  title: "Day 2: Your Market",
                  description:
                    "Get clear on who your coaching is for and the transformation it provides them.",
                },
                {
                  title: "Day 3: Your Finances",
                  description:
                    "Demystify your numbers, calculate your rates, and create a revenue plan that supports your desired lifestyle.",
                },
                {
                  title: "Day 4: Your Business Model",
                  description:
                    "Redefine your discovery call, design your offer stack, and optimize your practice for lasting success.",
                },
                {
                  title: "Day 5: Your Sales & Marketing",
                  description:
                    "Build a simple, service-driven sales and marketing system to consistently attract and effortlessly enroll clients.",
                },
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <SvgVerified className="w-5 text-[#4750f5] h-5 mt-1" />
                  <div>
                    <p className="text-black font-bold text-[16px] inline">
                      {item.title}
                    </p>{" "}
                    <p className="text-black text-[16px] font-normal">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <>
              {[
                {
                  title: "ADOPT AN ENTREPRENEURIAL MINDSET:",
                  description:
                    "Learn how to shift your vision, habits, and mindset to support your success.",
                },
                {
                  title: "DESIGN AN AUTHENTIC BRAND:",
                  description:
                    "Clarify your unique value and ideal client to build an aligned brand identity that's an extension of you.",
                },
                {
                  title: "CRAFT YOUR SIGNATURE COACHING PROGRAM:",
                  description:
                    "Structure your services with a high-value, adaptable offer that meets the needs of your ideal client and generates consistent revenue.",
                },
                {
                  title: "FINETUNE YOUR OPERATIONS:",
                  description:
                    "Implement proven systems for upleveling key business activities like enrollment flow, content creation, and practice management.",
                },
                {
                  title: "DEVELOP YOUR PRICING STRATEGY:",
                  description:
                    "Enhance the value of your coaching, calculate your pricing strategy, and break through limiting financial beliefs to confidently set rates that allow you to thrive.",
                },
                {
                  title: "BUILD YOUR BUSINESS BLUEPRINT:",
                  description:
                    "Experience continued growth and success long after the program ends by establishing the core components of your business and processes you can follow for years to come.",
                },
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <SvgVerified className="w-5 h-5 text-[#4750f5] flex-shrink-0 mt-1" />
                  <div>
                    <p className="text-black text-[16px] font-[bold] inline">
                      {item.title}
                    </p>{" "}
                    <span className="text-black text-[16px] font-normal">
                      {item.description}
                    </span>
                  </div>
                </div>
              ))}
            </>
          )}
          {isBootcamp && (
            <div className="w-full flex justify-start">
              {isCountdownActive ? (
                <Button
                  variant="default"
                  onClick={handleBootcampRegistration}
                  className="px-4 py-2 bg-[#4750F5] text-white items-center gap-2 rounded-lg"
                >
                  <span>{"\u{1F449}"}</span> SAVE YOUR SEAT
                </Button>
              ) : (
                <Button
                  variant="default"
                  asChild
                  className="px-4 py-2 bg-[#4750F5] text-white items-center gap-2 rounded-lg"
                >
                  <a
                    href="https://form.jotform.com/253005569459161"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>{"\u{1F449}"}</span> JOIN WAITLIST
                  </a>
                </Button>
              )}
            </div>
          )}
          <div></div>
        </div>

        {/* Image Section */}
        <div className="relative flex-shrink-0">
          {/* first yellow */}
          <div
            className="absolute bg-[#FFD700] 
               w-[470px] h-[518px] md:w-[50px] md:h-[398px] 
               lg:w-[470px] lg:h-[518px]"
            style={{ top: "0px", left: "100%", bottom: "20px" }}
          ></div>

          {/* second yellow */}
          <div
            className="absolute bg-[#FFD700] 
               w-[470px] h-[470px] md:w-[350px] md:h-[350px] 
               lg:w-[470px] lg:h-[470px]"
            style={{ top: "48px", left: "0px" }}
          ></div>

          {/* Image */}
          <div className="relative z-10 overflow-hidden">
            <img
              src={ProductImage}
              alt="Coaching session visual"
              className="w-[450px] h-[450px] md:w-[350px] md:h-[350px] lg:w-[450px] lg:h-[450px] object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProgramOverview
